import React from 'react';
import { FormGroup, LogEntryWithType } from '@/types/TInbox';

interface IntakeFormsPanelProps {
	formGroups: FormGroup[];
	onFormSelect: (formLog: LogEntryWithType) => void;
}

const IntakeFormsPanel: React.FC<IntakeFormsPanelProps> = ({ formGroups, onFormSelect }) => {
	const handleFormClick = (form: FormGroup) => {
		const formLog: LogEntryWithType = {
			id: `form_${form.id}`,
			date: form.responses[0]?.date || new Date().toISOString(),
			timeAgo: 'now',
			isToday: true,
			type: 'form',
			contact: {
				name: form.responses[0]?.name,
				phone: form.responses[0]?.phone || '',
			},
			message: `Intake form: ${form.title}`,
			status: 'pending',
			formGroup: form,
			originalLog: form.responses[0]?.log?.originalLog,
		};

		console.log('Selecting form group:', {
			formId: form.id,
			formTitle: form.title,
			responsesCount: form.responses.length,
			formGroup: form,
		});

		onFormSelect(formLog);
	};

	return (
		<div className="h-full bg-white overflow-y-auto">
			<div className="p-6">
				<div className="mb-6">
					<h2 className="text-xl font-semibold text-gray-900 mb-2">Intake Forms</h2>
				</div>

				{formGroups.length > 0 ? (
					<div className="space-y-4">
						{formGroups.map((form) => (
							<div
								key={form.id}
								className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-all duration-200"
							>
								<div className="p-5">
									<div className="mb-4">
										<h3 className="text-lg font-semibold text-gray-900 mb-2">{form.title}</h3>
										<p className="text-blue-600 font-medium text-sm">
											{form.responses.length} response{form.responses.length !== 1 ? 's' : ''}
										</p>
									</div>

									{form.scenario && (
										<div className="mb-4 p-3 bg-purple-50 rounded border-l-4 border-purple-400">
											<p className="text-xs font-medium text-purple-800 mb-1">Scenario:</p>
											<p className="text-sm text-purple-700">{form.scenario}</p>
										</div>
									)}

									<div className="mb-4">
										<p className="font-medium text-sm text-gray-700 mb-2">Questions:</p>
										<div className="space-y-2">
											{form.questions.map((question, qIndex) => (
												<div key={qIndex} className="flex items-start space-x-2">
													<span className="w-5 h-5 bg-blue-500 text-white rounded-full text-xs font-bold flex items-center justify-center flex-shrink-0 mt-0.5">
														{qIndex + 1}
													</span>
													<span className="text-gray-700 text-sm">{question}</span>
												</div>
											))}
										</div>
									</div>

									<div className="text-center">
										<button
											onClick={() => handleFormClick(form)}
											className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-lg transition-colors duration-200"
										>
											View Responses
										</button>
									</div>
								</div>
							</div>
						))}
					</div>
				) : (
					<div className="text-center py-12">
						<div className="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center mx-auto mb-4">
							<span className="text-2xl text-gray-400">📋</span>
						</div>
						<h3 className="text-lg font-medium text-gray-900 mb-2">No intake forms found</h3>
						<p className="text-gray-500">Forms with valid responses will appear here</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default IntakeFormsPanel;
